module.exports = "/images/ar.850fdd60f536b21f9abef401db05945d.svg";